import { IconTypes } from './Icons'

export default function VsIcon({
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
  opacity = 1,
  width,
  height,
}: Readonly<IconTypes>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='28'
      viewBox='0 0 15 28'
      fill='none'
      style={{
        width: width,
        height: height,
        fontSize,
        transform: `rotate(${rotate}deg)`,
        opacity: typeof opacity === 'number' ? opacity : 1,
      }}
      className={className}
    >
      <g clip-path='url(#clip0_5104_52584)'>
        <path
          d='M14.8536 14.8332C15.3142 12.6598 14.8064 10.5996 11.4115 10.5996C10.7005 10.5996 10.0503 10.696 9.4662 10.878L6.50274 17.3847C6.92903 17.9616 7.61522 18.4765 8.59303 19.0282C10.1155 19.881 10.492 20.457 10.2725 21.4364C10.0915 22.2405 9.63689 22.8761 8.66508 22.8761C7.66496 22.8761 7.50457 22.0761 7.68212 20.914H4.37728C3.9081 23.3163 4.54883 25.2775 8.09126 25.2775C11.3618 25.2775 13.1879 23.4136 13.7145 21.0741C14.2489 18.6945 13.3543 17.5776 10.9509 16.257C9.53911 15.4881 9.30838 15.0696 9.49022 14.2588C9.66777 13.469 10.1061 13.0002 10.8506 13.0002C11.8009 13.0002 11.7967 13.8471 11.6311 14.8324H14.8536V14.8332Z'
          fill='white'
        />
        <path
          d='M13.0898 0C11.8916 2.27736 10.7294 4.57234 9.6023 6.88408H6.56336L4.92509 11.1101C4.22432 12.9037 3.43693 14.8054 2.90771 16.4916H2.81164C3.02951 14.8574 3.19762 12.8827 3.29369 11.069L3.57674 6.93439H0.0274474L0 19.7207H3.78602C2.63495 22.4617 1.53191 25.2221 0.478614 28C5.24846 18.9232 9.46678 9.57063 13.0898 0Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_5104_52584'>
          <rect width='15' height='28' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
